module.exports = __webpack_public_path__ + "img/B高通25.3443d63d.png";